export default __webpack_public_path__ + "static/media/075-south africa.683cb6e8.svg";